/**
 * jaiio-product-buy.js — achat sur la fiche produit (T039).
 *
 * 1. « Dans le panier » : chaque zone d'achat (`[data-pp-buy]` : bouton de la
 *    colonne, barre mobile) porte l'id de sa variante. Quand le panier change
 *    (`cart:updated`, émis par Focal après un ajout comme après un retrait dans
 *    le tiroir), le bouton d'ajout (`[data-pp-add]`) et le lien « Dans le
 *    panier » (`[data-pp-incart]`) s'échangent — une pièce unique ne s'ajoute
 *    pas deux fois ; retirée du panier, elle redevient achetable.
 * 2. Pièce vendue : le bouton « Alerte nouveautés {marque} » déclenche la
 *    mécanique d'alerte commune (`assets/save-search.js`).
 *
 * Balisage : `snippets/product-form.liquid`, `snippets/product-sticky-form.liquid`,
 * `snippets/product-in-cart-link.liquid`. L'état initial vient du serveur.
 */
(function () {
  'use strict';

  if (window.__jaiioProductBuy) return; // section rendue deux fois (éditeur)
  window.__jaiioProductBuy = true;

  // Focal désactive le bouton le temps de l'ajout (`loader-button`) : le focus
  // tombe sur la page avant `cart:updated`. On retient le bouton qui l'avait, pour
  // que le lien qui le remplace le reprenne — et que le tiroir, refermé, y rende
  // la main au lieu de la page (recette clavier T044).
  var submitter = null;
  document.addEventListener('submit', function (event) {
    submitter = event.submitter && event.submitter.matches('[data-pp-add]') && event.submitter === document.activeElement ? event.submitter : null;
  }, true);

  function sync(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var inCart = {};
    cart.items.forEach(function (item) { inCart[item.variant_id] = true; });

    document.querySelectorAll('[data-pp-buy]').forEach(function (zone) {
      var on = !!inCart[zone.getAttribute('data-pp-buy')];
      var add = zone.querySelector('[data-pp-add]');
      var link = zone.querySelector('[data-pp-incart]');
      if (!add || !link || link.hidden === !on) return;
      // Le bouton qui vient de servir disparaît : le focus passe au lien qui le
      // remplace, sans quoi il retomberait sur la page.
      var active = document.activeElement;
      var hadFocus = on ? active === add || (submitter === add && (!active || active === document.body)) : active === link;
      add.hidden = on;
      link.hidden = !on;
      if (hadFocus) (on ? link : add).focus();
    });
    submitter = null;
  }

  document.documentElement.addEventListener('cart:updated', function (event) {
    sync(event.detail && event.detail.cart);
  });

  // Page restituée par le cache du navigateur (retour arrière) : le panier a pu
  // changer ailleurs entre-temps, l'état rendu par le serveur ne vaut plus.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var routes = (window.themeVariables && window.themeVariables.routes) || {};
    fetch((routes.cartUrl || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(sync, function () { /* hors ligne : l'état affiché reste */ });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-pp-sold-alert]');
    if (!trigger || !window.jaiioSaveSearch) return;
    window.jaiioSaveSearch.open(trigger);
  });

  // Le résumé Alma, la police et la safe area peuvent changer la hauteur du
  // sticky. Réserver sa hauteur réelle et placer lanceur/badge Zendesk au-dessus.
  var stickyObserver;
  function observeStickyBar() {
    if (stickyObserver) stickyObserver.disconnect();
    var bar = document.querySelector('.pp-bar');
    if (!bar) {
      document.documentElement.style.removeProperty('--pp-bar-height');
      return;
    }
    function measure() {
      document.documentElement.style.setProperty('--pp-bar-height', Math.ceil(bar.getBoundingClientRect().height) + 'px');
    }
    measure();
    if ('ResizeObserver' in window) {
      stickyObserver = new ResizeObserver(measure);
      stickyObserver.observe(bar);
    }
  }
  observeStickyBar();
  document.addEventListener('shopify:section:load', observeStickyBar);
  document.addEventListener('shopify:section:unload', observeStickyBar);
  window.addEventListener('resize', observeStickyBar);
})();
